<template>
  <v-app>
    <v-main>
      <iframe
        v-if="isCmsReady"
        :src="frameUrl"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </v-main>

    <v-dialog v-model="isOpenEditor" width="1400" slider-size="0" persistent data-testid="dialog-editor">
      <v-card data-testid="dialog-editor-content">
        <v-card-title class="text-center justify-center py-6">
          <v-btn
            class="mr-2"
            dark
            color="green"
            @click="update"
            cy-id="btn-update"
          >
            <v-icon v-if="campaignIsLoadingUpdate">mdi-timer-sand</v-icon>
            Update
          </v-btn>
          <v-select
            label="Current Page"
            :items="views"
            @input="setPage"
          >
          </v-select>
          <v-spacer></v-spacer>
          <v-btn
            @click="isOpenEditor = false"
            icon
            color="danger"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text v-if="!campaignIsLoadingGet">
          <v-tabs v-model="activeTabIndex">
            <v-tab data-testid="admin-tab-campaign">Campaign</v-tab>
            <v-tab data-testid="admin-tab-music">Community Playlist</v-tab>
            <v-tab data-testid="admin-tab-theme">Theme</v-tab>
            <v-tab data-testid="admin-tab-page-modules">Page modules</v-tab>
            <v-tab data-testid="admin-tab-user-journey">User Journey</v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTabIndex">
            <v-tab-item class="ma-4">
              <BuilderCampaign />
            </v-tab-item>
            <v-tab-item class="ma-4">
              <BuilderMusic />
            </v-tab-item>
            <v-tab-item class="ma-4">
              <BuilderTheme />
            </v-tab-item>
            <v-tab-item class="ma-4">
              <BuilderPageModules />
            </v-tab-item>
            <v-tab-item class="ma-4">
              <BuilderUserJourney />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div id="floating-button">
      <v-btn color="blue darken-2" dark fab @click="isOpenEditor = true">
        <v-icon>mdi-cogs</v-icon>
      </v-btn>
    </div>
  </v-app>
</template>

<script lang="ts">
import cms from '../cms'
import { ThemeState } from '@/store/modules/theme'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { AppHandler } from '../mixins/app-handler'
import { BridgeHandler } from '../mixins/bridge-handler'
import BuilderCampaign from './components/BuilderCampaign.vue'
import BuilderMusic from './components/BuilderMusic.vue'
import BuilderTheme from './components/BuilderTheme.vue'
import BuilderPageModules from './components/BuilderPageModules.vue'
import BuilderUserJourney from './components/BuilderUserJourney.vue'

export enum View {
  HOME = 'home',
  LOADING = 'loading',
  LOGIN = 'login',
  TRACKS = 'tracks',
  NEWSLETTER = 'newsletter',
  ONBOARDING = 'onboarding',
  RESULT = 'result',
  END = 'end',
}

@Component({
  components: {
    BuilderCampaign,
    BuilderMusic,
    BuilderTheme,
    BuilderPageModules,
    BuilderUserJourney,
  },
})
export default class AppAdmin extends Mixins(BridgeHandler, AppHandler) {
  @Action('UPDATE_CAMPAIGN') updateCampaign!: () => Promise<void>

  @Getter campaignId!: number
  @Getter campaignIsLoadingGet!: boolean
  @Getter campaignIsLoadingCreate!: boolean
  @Getter campaignIsLoadingUpdate!: boolean

  isOpenEditor = true
  isSaveLoading = false
  views: View[] = Object.values(View)

  activeTabIndex = 0

  get frameUrl () {
    console.log('cms.campaign', cms.campaign)
    return cms.campaign.url
  }

  @Watch('$store.state.theme', { deep: true })
  watchThemeState (state: ThemeState) {
    this.$bridgeMessageTheme(state)
  }

  async created () {
    await this.$appInit()
  }

  setPage (view: View) {
    this.$bridgeMessageView(view)
  }

  async update () {
    await this.updateCampaign()
  }
}

</script>

<style>
#floating-button {
  position: fixed;
  bottom: 16px;
  left: 16px;
}
</style>
